import { Injectable } from "@angular/core";
import { ApiService } from "@tylertech/core-module";
import { ICardData } from "@tylertech/tyler-api-types";
@Injectable()
export class MapService
{
    constructor(
        private readonly $apiService: ApiService
    ) { }

    Search(points: string): Promise<ICardData[]>
    {
        return this.$apiService.sendAuth("IMapService/Search", points);
    }
}
